import { useMemo } from 'react';
import { getClients } from '../requests.mjs';
import useResult from '../response';

export default function useGetClients(auth, params = null) {
  const request = useMemo(
    function () {
      return getClients(auth, params);
    },
    [params]
  );
  return useResult(request);
}
